import { QuestionForMain } from "@/components/features/_layouts/island/main/question";
import { QuestionSectionWrapper } from "@/components/features/items/edit/_shared/ui/components/system/question/_layouts/item-wrapper";

import { InputNumberField } from "@/components/ui/form/fields/input-field/input-number";

import { useVoucherPrice } from "./hooks";

export const QuestionVoucherPrice = () => {
	const { voucherPrice, onSetVoucherPriceAmount } = useVoucherPrice();

	const title = "適用価格";
	const guide = "予約時にクーポン適用される価格を設定します。";

	return (
		<QuestionForMain
			required={true}
			title={title}
			guide={guide}
			inputChildren={
				<QuestionSectionWrapper>
					<p>適用価格：</p>
					<InputNumberField
						value={voucherPrice.amount?.value}
						handleInput={onSetVoucherPriceAmount}
						errorMessage={voucherPrice.amount?.error}
					/>
					<p>円（税込）</p>
				</QuestionSectionWrapper>
			}
		/>
	);
};

QuestionVoucherPrice.displayName = "QuestionVoucherPrice";
